"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const ReactDOM = require("react-dom");
const react_redux_1 = require("react-redux");
const OverviewModalRow_1 = require("./OverviewModalRow");
const NotificationContainer_1 = require("../notification/NotificationContainer");
const ScheduledDelivery_1 = require("../ScheduledDelivery");
const AutomatedDelivery_1 = require("../AutomatedDelivery");
const reducers_1 = require("../../../reducers");
const actions_1 = require("../../../actions");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const getCampaignType_1 = require("../../utils/getCampaignType");
const APIDelivery_1 = require("../APIDelivery");
const OverviewModalBodyContainer = ({ notificationProgress, currentWizard, scheduledDeliveryProgress, apiDeliveryProgress, device, openWizardModal, updateTags, trigger, automatedDeliveryProgress, campaignTags, campaignId, getAllTags, tagOptions, }) => {
    React.useEffect(() => {
        getAllTags();
    }, []);
    let arr = [];
    if (getCampaignType_1.isScheduledCampaignTrigger(trigger)) {
        arr = [
            {
                name: 'Scheduled Delivery',
                text: 'Determine how and when the notification is delivered as well as which devices/users will receive it.',
                val: scheduledDeliveryProgress,
            },
            {
                name: 'Notification',
                text: 'Compose the title and body of notification, add rich media and determine what happens when the user taps or swipes the notification.',
                val: notificationProgress,
            },
        ];
    }
    if (getCampaignType_1.isAutomatedCampaignTrigger(trigger)) {
        arr = [
            {
                name: 'Automated Delivery',
                text: 'Determine how and when the notification is delivered as well as which devices/users will receive it.',
                val: automatedDeliveryProgress,
            },
            {
                name: 'Notification',
                text: 'Compose the title and body of notification, add rich media and determine what happens when the user taps or swipes the notification.',
                val: notificationProgress,
            },
        ];
    }
    if (getCampaignType_1.isAPICampaignTrigger(trigger)) {
        arr = [
            {
                name: 'Delivery',
                text: 'View and customize the API request used to trigger the notification.',
                val: apiDeliveryProgress,
            },
            {
                name: 'Notification',
                text: 'Compose the title and body of notification, add rich media and determine what happens when the user taps or swipes the notification.',
                val: notificationProgress,
            },
        ];
    }
    const openSelectedWizard = (wizard) => openWizardModal(wizard);
    const handleSelectedChange = (newSelection) => {
        updateTags(campaignId, newSelection);
    };
    return (React.createElement("div", { style: {
            width: '100%',
            flex: 'auto',
            marginBottom: 80,
            overflowY: 'scroll',
        } },
        arr.map((row) => (React.createElement(OverviewModalRow_1.default, Object.assign({}, row, { device: device, openWizard: openSelectedWizard, key: row.name })))),
        React.createElement(OverviewModalRow_1.default, { device: device, name: 'Tags', text: 'Keywords to help with search and organization' },
            React.createElement(src_1.MultiSelectInput, { style: {
                    marginTop: 8,
                }, selected: campaignTags, options: tagOptions, onSelectedChange: handleSelectedChange })),
        currentWizard === 'notification' &&
            ReactDOM.createPortal(React.createElement(NotificationContainer_1.default, { device: device }), document.getElementById('mainModalLeft')),
        currentWizard === 'scheduleddelivery' &&
            ReactDOM.createPortal(React.createElement(ScheduledDelivery_1.default, { device: device }), document.getElementById('mainModalLeft')),
        currentWizard === 'automateddelivery' &&
            ReactDOM.createPortal(React.createElement(AutomatedDelivery_1.default, { device: device }), document.getElementById('mainModalLeft')),
        currentWizard === 'delivery' &&
            ReactDOM.createPortal(React.createElement(APIDelivery_1.default, { device: device }), document.getElementById('mainModalLeft'))));
};
const mapStateToProps = (state) => ({
    currentWizard: reducers_1.getCurrentWizard(state),
    notificationProgress: reducers_1.getTypeProgress(state.editableCampaign, state.editableUIState, 'notification'),
    scheduledDeliveryProgress: reducers_1.getTypeProgress(state.editableCampaign, state.editableUIState, 'scheduleddelivery'),
    automatedDeliveryProgress: reducers_1.getTypeProgress(state.editableCampaign, state.editableUIState, 'automateddelivery'),
    apiDeliveryProgress: reducers_1.getTypeProgress(state.editableCampaign, state.editableUIState, 'delivery'),
    tagOptions: reducers_1.getTags(state, ''),
});
const mapDispatchToProps = (dispatch) => {
    return {
        openWizardModal: (stateType) => dispatch(actions_1.openWizardModal(stateType)),
        updateTags: (id, tags) => dispatch(actions_1.updateTags(id, tags)),
        getAllTags: () => dispatch(actions_1.getAllTags('')),
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(OverviewModalBodyContainer);
